<template>
  <div :class="{ 'is-invalid': showValidationError }">
    <label :for="inputId">
      <required v-if="required" />
      {{ i18n.t('activerecord.attributes.user.password') }}
    </label>
    <input :id="inputId" type="password" :name="inputName" autocomplete="current-password"
           :class="['form-control form-control-lg', {'is-invalid': showValidationError}]" :value="value" @input="setValue">
    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import Required from '../required'
import ValidationErrors from './validation-errors'

export default {
  components: { Required, ValidationErrors },

  props: {
    inputId: {
      type: String,
      required: false,
      default: 'user_password'
    },
    inputName: {
      type: String,
      required: false,
      default: 'user[password]'
    },
    required: {
      type: Boolean,
      required: false,
      default: true
    },
    validationErrors: {
      type: Array,
      required: false
    },
    value: {
      type: String,
      required: false
    }
  },

  emits: ['input'],

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  methods: {
    setValue(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
